import readMore from 'utils/read-more/read-more'

export default function () {
  return Array.from(document.querySelectorAll('[data-read-more]')).map(el => readMore(el))
}
